import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { DownloadIcon, CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferBlock() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const includes = ['The 48-Hour Recovery Guide', 'The Activity Menu Matrix', 'The Boredom Bridge Scripts', 'The Screen-Free Home Audit', 'The Sustainable Screen Rulebook'];
  return <section id="offer" ref={ref} className="px-6 py-24" style={{
    backgroundColor: 'var(--color-background-alt)'
  }} data-id="element-64">
      <div className="max-w-2xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-center mb-8" data-id="element-66">
          <p className="text-lg mb-4" style={{
          color: 'var(--color-text)',
          opacity: 0.8
        }} data-id="element-67">
            Reclaim your home and your child's focus for less than the cost of a
            takeout pizza.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="p-8 md:p-10 rounded-2xl text-center" style={{
        backgroundColor: 'var(--color-background)',
        border: '2px solid var(--color-accent)'
      }} data-id="element-68">
          <h2 className="text-2xl md:text-3xl font-bold mb-2" style={{
          fontFamily: 'var(--font-heading)',
          color: 'var(--color-text)'
        }} data-id="element-69">
            The 48-Hour Parent Recovery Plan
          </h2>

          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-4" style={{
          backgroundColor: 'var(--color-highlight)'
        }} data-id="element-70">
            <span className="text-sm font-semibold" style={{
            color: '#065F46'
          }} data-id="element-71">
              70% OFF
            </span>
          </div>

          <div className="flex items-baseline justify-center gap-3 mb-6" data-id="element-72">
            <span className="text-2xl line-through opacity-40" style={{
            color: 'var(--color-text)'
          }} data-id="element-73">
              $33.30
            </span>
            <span className="text-5xl md:text-6xl font-bold" style={{
            color: 'var(--color-accent)'
          }} data-id="element-74">
              $9.99
            </span>
            <span className="text-lg opacity-60" style={{
            color: 'var(--color-text)'
          }} data-id="element-75">
              one-time
            </span>
          </div>

          <ul className="text-left max-w-sm mx-auto mb-8 space-y-3" data-id="element-76">
            {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-77">
                <CheckIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--color-accent)'
            }} data-id="element-78" />
                <span style={{
              color: 'var(--color-text)'
            }} data-id="element-79">
                  {item}
                </span>
              </li>)}
          </ul>

          <a href="https://www.versastorex.com/cart/42104259772496:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="w-full py-4 px-8 text-lg font-semibold text-white rounded-lg transition-all duration-200 hover:scale-[1.02] flex items-center justify-center gap-2" style={{
          backgroundColor: 'var(--color-accent)'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'var(--color-accent-hover)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'var(--color-accent)'} data-id="element-80">
            <DownloadIcon className="w-5 h-5" data-id="element-81" />
            Get the Recovery Plan Now
          </a>

          <p className="mt-4 text-sm opacity-60" style={{
          color: 'var(--color-text)'
        }} data-id="element-82">
            Instant PDF Download. Start your reset tonight.
          </p>
        </motion.div>
      </div>
    </section>;
}